import * as clipboard from 'clipboard-polyfill';
import { Module } from '../Module';
import { RevokePersonalAccessTokenRequest } from '../ServerApi/requests/RevokePersonalAccessTokenRequest';
import { ServerService } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';

// Scope interface used by the controller class.
export interface ICreatePersonalAccessTokenDialogScope extends ng.IScope {
    personalAccessTokenName: string;
    personalAccessTokenSecret: string;
    discardToken: () => void;
    copyToken: () => void;
    dismiss: () => void;
    close: () => void;
}

export interface PersonalAccessToken {
  tokenName: string;
  tokenSecret: string;
}

export class CreatePersonalAccessTokenDialogCtrl {

  public static $inject = [
    '$scope',
    '$q',
    '$translate',
    'token',
    'ServerService',
  ];

  constructor(
    private $scope: ICreatePersonalAccessTokenDialogScope,
    private $q: ng.IQService,
    private $translate: ng.translate.ITranslateService,
    private token: PersonalAccessToken,
    private serverService: ServerService,
    ) {
    $scope.personalAccessTokenName = token.tokenName;
    $scope.personalAccessTokenSecret = token.tokenSecret;

    $scope.discardToken = () => {
      this.serverService.sendRequest(new RevokePersonalAccessTokenRequest({
        refreshToken : token.tokenSecret
      })).then(() => {
        $scope.close();
      });
    };

    $scope.copyToken = () => {
      clipboard.writeText(token.tokenSecret);
      ToasterService.instance.pop({ type: ToastType.Info, text: $translate.instant('personalAccessTokensTokenCopied') });
    };
  }
}

Module.instance().controller('CreatePersonalAccessTokenDialogCtrl', CreatePersonalAccessTokenDialogCtrl);
